import { render, staticRenderFns } from "./epms9065.vue?vue&type=template&id=70f6958e&scoped=true"
import script from "./epms9065.vue?vue&type=script&lang=js"
export * from "./epms9065.vue?vue&type=script&lang=js"
import style0 from "./epms9065.vue?vue&type=style&index=0&id=70f6958e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6958e",
  null
  
)

export default component.exports